import {getPageTitle} from '~/utils/seoUtils'
import {isEmpty} from "lodash"
import {getPageMetadata} from 'assets/staticPagesSeo'

export function useSEOData(pageId, options = {defaultRobots: 'noindex,nofollow', reverseTitle: false}) {
  if (!pageId) {
    console.warn('useSEOData: pageId is required')
    return
  }
  const currentPageId = ref(pageId)

  const setMetas = (data) => {
    const config = useRuntimeConfig()
    data.title = getPageTitle(data.title, config.public.pageTitle, options?.reverseTitle || false)
    useHead(data)
  }

  const setPageId = (pageId) => {
    currentPageId.value = pageId
  }

  watch(currentPageId, () => {
    const pageMetas = getPageMetadata(currentPageId.value)
    if(!pageMetas || isEmpty(pageMetas)) return

    setMetas(pageMetas)
  }, {immediate: true})

  return {
    setPageId
  }
}
